import React from "react";
import "./JsonView.scss";

interface JsonViewerProps {
  data: any;
  indentSize?: number;
}

const JsonViewer: React.FC<JsonViewerProps> = ({ data, indentSize = 16 }) => {
  const renderValue = (value: any, level: number = 0) => {
    const indentStyle = { marginLeft: `${level * indentSize}px` };

    if (Array.isArray(value)) {
      return (
        <div className="indent" style={indentStyle}>
          <span className="brace">[</span>
          {value.map((item, index) => (
            <div key={index}>{renderValue(item, level + 1)}</div>
          ))}
          <span className="brace">]</span>
        </div>
      );
    }

    if (value !== null && typeof value === "object") {
      return (
        <div className="indent" style={indentStyle}>
          <span className="brace">{'{'}</span>
          {Object.entries(value).map(([key, val]) => (
            <div
              key={key}
              className="indent"
              style={{ marginLeft: `${(level + 1) * indentSize}px` }}
            >
              <span className="key">"{key}": </span>
              {renderValue(val, level + 1)}
            </div>
          ))}
          <span className="brace">{'}'}</span>
        </div>
      );
    }

    if (typeof value === "string") return <span className="string">"{value}"</span>;
    if (typeof value === "number") return <span className="number">{value}</span>;
    if (typeof value === "boolean") return <span className="boolean">{String(value)}</span>;
    if (value === null) return <span className="null">null</span>;

    return <span>{String(value)}</span>;
  };

  return <div className="jsonViewer">{renderValue(data)}</div>;
};

export default JsonViewer;
